import { Injectable } from '@angular/core';

import { REFCLI_TYPE } from '@app/baseBtl/context/contract.interface';
import { Oauth2RessourceService } from '@app/oauth2/oauth2-resources.service';

import { Oauth2StorageService } from '@common';

import { RenewContextServiceBase } from '../../baseBtl/context/child/renew-context.service';
import { RenewStorageService } from '../../catalog/category/renew/renew-storage.service';
import { ProductsService } from '../../catalog/products.service';
import { PromoContextService } from './promo-context.service';

@Injectable({
    providedIn: 'root',
})
export class RenewContextService extends RenewContextServiceBase {
    public idOffre: string;

    constructor(
        oauth2Ressource: Oauth2RessourceService,
        products: ProductsService,
        promoContextService: PromoContextService,
        renewStorageService: RenewStorageService,
        private oauth2Storage: Oauth2StorageService,
    ) {
        super(oauth2Ressource, products, promoContextService, renewStorageService);
    }

    protected setData(responses: any): void {
        /**
         * responses[0] -- Contrat;
         * responses[1] -- Eligibilité Renouvellement
         * responses[2] -- Abonnement
         * responses[3] -- Options
         * responses[4] -- Offre
         */

        super.setData(responses);

        this.idOffre = responses[4].entity_id;
    }

    public getContractId(): string {
        return this.oauth2Storage.getItem(this.oauth2Storage.KEY.CONTRACT_ID);
    }

    public setContractId(contractId: string): void {
        this.oauth2Storage.setItem(this.oauth2Storage.KEY.CONTRACT_ID, contractId);
    }

    public isPro(): boolean {
        return this.statut === REFCLI_TYPE.ENTREPRISE;
    }
}
